import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { PostConsultationRequest } from '@/types/api';
import { postConsultation } from '../apis/user';

export const useConsultation = (options?: UseMutationOptions<any, any, PostConsultationRequest>) => {
  return useMutation<any, any, PostConsultationRequest>({
    mutationFn: postConsultation,
    ...options
  });
};
